import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BaseResponse, UserCalendarDayResponse, User } from "../core/core.component";
import { Http, Headers, URLSearchParams} from '@angular/http'; 
import { AppConstants } from '../core/app.constants';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class UserCalendarService {

    private userExtraWorkComponentStatus = new Subject<User>();

    private userCalendarComponentStatus = new Subject<User>();
    
    constructor(private http: Http,
                private datePipe: DatePipe) { }

    getUserExtraWorkComponentStatus() : Observable<User> {
        return this.userExtraWorkComponentStatus.asObservable();
    }
    
    openUserExtraWorkComponent(user: User) {
        this.userExtraWorkComponentStatus.next(user);
    }

    closeUserExtraWorkComponent() {
        this.userExtraWorkComponentStatus.next();
    }

    getUserCalendarComponentStatus() : Observable<User> {
        return this.userCalendarComponentStatus.asObservable();
    }
    
    openUserCalendarComponent(user: User) {
        this.userCalendarComponentStatus.next(user);
    }

    closeUserCalendarComponent() {
        this.userCalendarComponentStatus.next();
    }
    
    insert(srmToken, date: Date, userId: number, workday?: boolean) : Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/userCalendar/insert";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        headers.append("Content-Type", "application/json; charset=UTF-8");
        let  body = {
             date:  this.datePipe.transform(date, "yyyyMMdd"), 
             userId: userId,
             workday: workday
        };
        return this.http.post(url, body, {headers: headers}).map((responseData) => responseData.json());
    }

    delete(srmToken, date: Date, userId: number): Observable<BaseResponse> {  
        let formattedDate : string = "";
        if(date != null) {
            formattedDate = this.datePipe.transform(date, "yyyyMMdd")            
        }
        var url = environment.REST_SERVICE_BASE_URL + "/userCalendar/" + formattedDate + "/" + userId;
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

        return this.http.delete(url, {headers: headers}).map((responseData) => responseData.json());
    }
    
    getUserCalendarDays(srmToken, dateFrom: Date, dateTo: Date, userId: number, workdays?: boolean) : Observable<UserCalendarDayResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/userCalendar";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        
        let params: URLSearchParams = new URLSearchParams();
        params.set('from', this.datePipe.transform(dateFrom, "yyyyMMdd"));
        params.set('to', this.datePipe.transform(dateTo, "yyyyMMdd"));
        params.set('userId', userId+"");
        if (workdays != null && typeof(workdays) != 'undefined') {
            params.set('workdays', workdays+'');
        }
       
        return this.http.get(url, {search: params, headers: headers}).map((responseData) => responseData.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/service/userCalendar.service.ts